import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Shield, Cloud, Landmark, GitBranch, Server, Settings, Bot, Box, Link as LinkIcon, Code } from 'lucide-react';

export const serviceIcons = { Shield, Cloud, Landmark, GitBranch, Server, Settings, Bot, Container: Box, Link: LinkIcon, Code };

// Deterministic bits so each card has its own digit field (stable across renders).
const field = (seed, title) => {
  let s = seed * 9301 + 49297;
  const rnd = () => ((s = (s * 9301 + 49297) % 233280) / 233280);
  const rows = Array.from({ length: 9 }, () => Array.from({ length: 30 }, () => (rnd() > 0.5 ? 1 : 0)).join(' '));
  const sig = title.slice(0, 3).split('').map((c) => c.charCodeAt(0).toString(2).padStart(8, '0')).join(' ');
  return { rows, sig };
};

const tilt = (e) => {
  const el = e.currentTarget, r = el.getBoundingClientRect();
  const x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
  el.style.setProperty('--mx', `${x * 100}%`); el.style.setProperty('--my', `${y * 100}%`);
  el.style.setProperty('--rx', `${(0.5 - y) * 6}deg`); el.style.setProperty('--ry', `${(x - 0.5) * 8}deg`);
};
const untilt = (e) => { e.currentTarget.style.setProperty('--rx', '0deg'); e.currentTarget.style.setProperty('--ry', '0deg'); };

const ServiceCard = ({ service, index, total = 10, specs = 4, className = '' }) => {
  const Icon = serviceIcons[service.icon] || Server;
  const { rows, sig } = useMemo(() => field(index + 1, service.title), [index, service.title]);
  const n = String(index + 1).padStart(2, '0');
  return (
    <article onMouseMove={tilt} onMouseLeave={untilt} className={`svc group ${className}`}>
      <div className="svc-field" aria-hidden>
        <div className="svc-digits">
          <pre className="font-mono text-[10px] leading-[1.7] tracking-[0.18em]">{rows.join('\n')}</pre>
          <pre className="font-mono text-[10px] leading-[1.7] tracking-[0.18em]">{rows.join('\n')}</pre>
        </div>
        <p className="svc-sig font-mono text-[10px] tracking-[0.18em]">{sig}</p>
        <span className="svc-scan" />
      </div>

      <div className="svc-ring"><Icon className="w-6 h-6" strokeWidth={1.4} /></div>
      <p className="svc-num font-mono-label"><span className="text-[var(--red)]">{n}</span> / {String(total).padStart(2, '0')}</p>

      <div className="svc-body">
        <h3 className="font-display text-[2rem] leading-[1.05]">{service.title}</h3>
        <p className="mt-3 text-sm leading-relaxed text-[var(--muted)]">{service.shortDesc}</p>
        <ul className="mt-5 space-y-2">
          {service.features.slice(0, specs).map((f) => (
            <li key={f} className="flex items-center gap-3 text-[0.8rem] border-b border-[var(--line)] pb-2 last:border-0">
              <span className="w-1.5 h-1.5 rotate-45 bg-[var(--red)] opacity-60 group-hover:opacity-100 transition-opacity" />{f}
            </li>
          ))}
        </ul>
      </div>

      <Link to="/contact" className="svc-go" aria-label={`Discuss ${service.title}`}>
        <span>Discuss</span>
      </Link>
    </article>
  );
};

export default ServiceCard;
